// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { InjectedFormProps } from 'redux-form'; // eslint-disable-line no-unused-vars
import { reduxForm } from 'utils/reduxFormWrapper';
import { customRequired } from 'utils/validation';
import HForm, { TextAreaField } from 'shared/containers/portal_layout/HForm';
import SpinnerButton from 'shared/components/SpinnerButton';
import styles from './OutOfGroupModal.module.scss';

const outOfGroupReasonRequired = customRequired(
  'A reason to send the referral out of group is required'
);

/** @typedef {{
  reason: string
}} OutOfGroupFormType */

/** @typedef {{
  onOutOfGroupReasonSubmit: (formValues: OutOfGroupFormType) => any
}} OutOfGroupModalPropsType */

/**
 * @todo these ought to be required, but don't exist when modal is not open
 * @type { React.ValidationMap<OutOfGroupModalPropsType> } */
const propTypes = {
  onOutOfGroupReasonSubmit: PropTypes.func,
};

/** @type { StatelessComponent<OutOfGroupModalPropsType> } */
const OutOfGroupModal = ({ onOutOfGroupReasonSubmit }) => (
  <FormifiedPresentationComponent form="outOfGroup" onSubmit={onOutOfGroupReasonSubmit} />
);

OutOfGroupModal.displayName = 'OutOfGroupModal';
OutOfGroupModal.propTypes = propTypes;

/** @typedef {
  InjectedFormProps<OutOfGroupFormType>
} PresentationComponentPropsType */

/** @type { React.ValidationMap<PresentationComponentPropsType> } */
const presentationComponentPropTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

/** @type { StatelessComponent<PresentationComponentPropsType> }  */
const PresentationComponent = ({ handleSubmit, submitting }) => (
  <div className={styles.modal}>
    <div className={styles.header}>
      <p className={styles.headerText}>
        In order to refer to this provider, please enter a reason for referring out of group
      </p>
    </div>
    <HForm onSubmit={handleSubmit}>
      <div className={styles.midsection}>
        <TextAreaField name="reason" label="Reason" validate={outOfGroupReasonRequired} />
      </div>
      <div className={styles.footer}>
        <SpinnerButton type="submit" className="btn btn-primary" loading={submitting}>
          Continue
        </SpinnerButton>
      </div>
    </HForm>
  </div>
);

PresentationComponent.displayName = 'PresentationComponent';
PresentationComponent.propTypes = presentationComponentPropTypes;

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default OutOfGroupModal;
